import clsx from 'clsx';
import React from 'react';
export const FaIcon = ({ icon, active, size, className, variant, fixedWidth, ...remainingProps }) => (React.createElement("i", { className: clsx(icon, className, { [`text-${variant}`]: variant }, { 'fa-fw': fixedWidth }, { [`fs-${size}`]: size }), ...remainingProps }));
FaIcon.displayName = 'FaIcon';
